import { refDebounced } from "@vueuse/core";
import { useQuery, defineQuery } from "@pinia/colada";

export const useAutocomplete = defineQuery(() => {
  const search = shallowRef("");
  const searchDebounced = refDebounced(search, 300, { maxWait: 3000 });
  const { data: autocomplete, isLoading, status, error } = useQuery<Autocomplete, Error, Autocomplete>({
    key: () => ["autocomplete", { search: searchDebounced.value }],
    query: async () => {
      if (!searchDebounced.value) return { results: [] };
      const response = await typesenseClient.collections<ProductDocument>("products").documents().search({
        q: searchDebounced.value,
        query_by: "name,short_description",
        per_page: 5,
      }, {});
      return v.parse(autocompleteSchema, { results: response.hits?.map((hit) => hit.document) || [] });
    },
    placeholderData: { results: [] },
  });
  return { search, autocomplete, isLoading, status, error };
});
